function logError() {
  if (process.env.NODE_ENV !== 'production' && typeof document !== 'undefined') {
    console.error(...arguments);
  }
}
export { logError };